import { getPathArea } from './get-path-area';
export function getDrawDirection(pathArray) {
    return getPathArea(pathArray) >= 0;
}
//# sourceMappingURL=get-draw-direction.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/layout/node_modules/@antv/util/esm/path/util/get-draw-direction.js
// module id = null
// module chunks = 